<template>
  <div class="acc_event_cla">
    <zkThreeRow>
      <div slot="search" class="acc_search_cla">
        <el-form :model="searchParams" :inline="true">
          <el-form-item label="">
            <el-select
              style="width: 140px;"
              v-model="searchParams.type"
              :placeholder="$t('sysOption.eventType')"
              clearable
            >
              <el-option
                v-for="item in selectOption"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchParams.value"
              :placeholder="$t('common.inputKeyWord')"
              clearable
              @clear="getAccEventCodeList"
            >
              <template slot="append">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  style="cursor: pointer;"
                  @click="getAccEventCodeList"
                ></el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <ZkButtonGroup
          :showText="true"
          @addEvent="addEvent"
          size="mini"
          :isLoadGroupName="true"
          groupName="btn_addEvent"
        ></ZkButtonGroup>
      </div>
      <div slot="table">
        <zk-table :data="tableData" :columns="column"></zk-table>
        <div class="pagination-margin-top">
          <el-pagination
            background
            @size-change="pageSizeChange(arguments[0], getAccEventCodeList)"
            @current-change="curPageChange(arguments[0], getAccEventCodeList)"
            :current-page="pager.curPage"
            :page-size="pager.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="pager.total"
          ></el-pagination>
        </div>
      </div>
    </zkThreeRow>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      @close="handleClose"
    >
      <el-form
        :model="formData"
        label-width="160px"
        :rules="rules"
        ref="dialog"
      >
        <el-form-item :label="$t('sysOption.originalType')" prop="originalType">
          <el-input
            v-model="formData.originalType"
            :placeholder="$t('sysOption.inputOriginalType')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('sysOption.standardType')" prop="standardType">
          <el-input
            v-model="formData.standardType"
            :placeholder="$t('sysOption.inputStandardType')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('sysOption.eventDesc')" prop="description">
          <el-card class="box-card">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-input
                  v-model="defaultDesc.lang"
                  :placeholder="$t('sysOption.inputDescName')"
                ></el-input>
              </el-col>
              <el-col :span="16">
                <el-input
                  v-model="defaultDesc.desc"
                  type="textarea"
                  :rows="3"
                  :placeholder="$t('sysOption.inputDescValue')"
                ></el-input>
              </el-col>
              <el-col :span="2" align="center">
                <i
                  class="el-icon-plus"
                  @click="addDesc"
                  style="cursor: pointer;"
                ></i>
              </el-col>
            </el-row>
            <template v-for="(item, index) in secondDesc">
              <el-row :gutter="10" :key="index" style="margin-top:10px;">
                <el-col :span="6">
                  <el-input
                    v-model="item.lang"
                    :placeholder="$t('sysOption.inputDescName')"
                  ></el-input>
                </el-col>
                <el-col :span="16">
                  <el-input
                    v-model="item.desc"
                    :placeholder="$t('sysOption.inputDescValue')"
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-col>
                <el-col :span="2" align="center">
                  <i
                    class="el-icon-minus"
                    @click="removeDesc(item, index)"
                    style="cursor: pointer;"
                  ></i>
                </el-col>
              </el-row>
            </template>
          </el-card>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="sumbitEventCode">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAccEventCodeList,
  addAccEventCodeList,
  updateAccEventCodeList,
  deleteAccEventCodeList
} from '@/services/sysOptionsApi.js'
// import { dateFormat, dateByTimestamp } from '../../../utils/utils.js'
export default {
  data() {
    let _self = this
    return {
      tableData: [],
      column: [
        {
          label: this.$t('sysOption.originalType'),
          prop: 'originalType'
        },
        {
          label: this.$t('sysOption.standardType'),
          prop: 'standardType'
        },
        // {
        //   label: '事件类型是否转换',
        //   props: 'type',
        //   render: (h, params) => {
        //     return h('span', {}, params.row.type === 1 ? '是' : '否')
        //   }
        // },
        // {
        //   label: '通讯协议',
        //   props: 'protocol',
        //   render: (h, params) => {
        //     let isData = this.isEmptyData(params.row.protocol)
        //     return h('span', {}, isData ? 'N/A' : params.row.protocol)
        //   }
        // },
        {
          label: this.$t('sysOption.desc'),
          prop: 'description',
          render: (h, params) => {
            return h('div', {}, params.row.description)
          }
        },
        // {
        //   label: '创建时间',
        //   props: 'createTime',
        //   render: (h, params) => {
        //     let isData = this.isEmptyData(params.row.createTime)
        //     return h(
        //       'span',
        //       {},
        //       isData
        //         ? 'N/A'
        //         : dateFormat(dateByTimestamp(params.row.createTime), null)
        //     )
        //   }
        // },
        // {
        //   label: '修改时间',
        //   props: 'updateTime',
        //   render: (h, params) => {
        //     let isData = this.isEmptyData(params.row.updateTime)
        //     return h(
        //       'span',
        //       {},
        //       isData
        //         ? 'N/A'
        //         : dateFormat(dateByTimestamp(params.row.updateTime), null)
        //     )
        //   }
        // },
        // {
        //   label: '创建者',
        //   props: 'createBy',
        //   render: (h, params) => {
        //     return h(
        //       'span',
        //       {},
        //       this.isEmptyData(params.row.createBy)
        //         ? 'N/A'
        //         : params.row.createBy
        //     )
        //   }
        // },
        // {
        //   label: '修改者',
        //   props: 'updateBy',
        //   render: (h, params) => {
        //     return h(
        //       'span',
        //       {},
        //       this.isEmptyData(params.row.updateBy)
        //         ? 'N/A'
        //         : params.row.updateBy
        //     )
        //   }
        // },
        {
          label: this.$t('common.operation'),
          render: (h, params) => {
            return h('ZkButtonGroup', {
              props: {
                showText: true,
                groupName: 'acc_event_code_btn_group',
                showTip: true,
                isLoadGroupName: true,
                params: params.row,
                size: 'mini',
                isGroup: true,
                event: event,
                onlyShowText: true
              },
              on: {
                editEvent() {
                  _self.editEvent(params.row)
                },
                deleteEvent() {
                  _self.deleteEvent(params.row)
                }
              }
            })
          }
        }
      ],
      searchParams: {
        type: '',
        value: ''
      },
      selectOption: [
        {
          label: this.$t('sysOption.originalType'),
          value: 0,
          attr: 'originalType'
        },
        {
          label: this.$t('sysOption.standardType'),
          value: 1,
          attr: 'standardType'
        }
      ],
      title: '',
      dialogVisible: false,
      isUpdate: false,
      formData: {
        originalType: '',
        standardType: ''
      },
      rules: {
        originalType: this.validatorInputEmptyRule(true, 32),
        standardType: this.validatorInputEmptyRule(true, 32)
      },
      defaultDesc: {
        lang: 'zh-cn',
        desc: ''
      },
      secondDesc: [
        {
          lang: 'en',
          desc: ''
        }
      ]
    }
  },
  methods: {
    sumbitEventCode() {
      this.$refs.dialog.validate(valid => {
        if (valid) {
          let description = {}
          description[this.defaultDesc.lang] = this.defaultDesc.desc
          this.secondDesc.forEach(item => {
            description[item.lang] = item.desc
          })
          let toConverJSON = JSON.stringify(description)
          let params = {
            ...this.formData,
            description: toConverJSON
          }

          if (this.isUpdate) {
            updateAccEventCodeList(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.successMessage(this.$t('successOperation.update'))
                  this.getAccEventCodeList()
                  this.handleClose()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {})
          } else {
            addAccEventCodeList(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.successMessage(this.$t('successOperation.add'))
                  this.getAccEventCodeList()
                  this.handleClose()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {})
          }
        }
      })
    },
    addDesc() {
      this.secondDesc.push({
        lang: '',
        desc: ''
      })
    },
    removeDesc(item, index) {
      this.secondDesc.splice(index, 1)
    },
    handleClose() {
      this.dialogVisible = false
      this.isUpdate = false
      setTimeout(() => {
        this.title = ''
        this.formData = {
          originalType: '',
          standardType: ''
        }
        this.secondDesc = [{ lang: 'en', desc: '' }]
        this.defaultDesc = {
          lang: 'zk-cn',
          desc: ''
        }
      }, 500)
    },
    addEvent() {
      this.title = this.$t('sysOption.addAccEventType')
      this.dialogVisible = true
      this.isUpdate = false
      // addAccEventCodeList().then(data=>{
      // })
    },
    editEvent(row) {
      this.title = this.$t('sysOption.updateAccEventType')
      this.dialogVisible = true
      this.isUpdate = true
      this.formData.originalType = row.originalType
      this.formData.standardType = row.standardType
      this.formData.id = row.id
      let description = JSON.parse(row.description)
      let keys = Object.keys(description).map(key => key)
      let defaultDesc = keys.shift()
      this.defaultDesc.lang = defaultDesc
      this.defaultDesc.desc = description[defaultDesc]
      this.secondDesc = []
      if (keys.length !== 0) {
        keys.forEach(item => {
          this.secondDesc.push({
            lang: item,
            desc: description[item]
          })
        })
      }
    },
    deleteEvent(row) {
      this.$confirm(this.$t('sysOption.deleteEvent'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteAccEventCodeList({
            id: row.id
          })
            .then(data => {
              if (data.code === '00000000') {
                this.successMessage(this.$t('successOperation.delete'))
                this.getAccEventCodeList()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => console.log(e))
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    getAccEventCodeList() {
      let finallyParams = {}
      if (this.searchParams.type !== '') {
        this.selectOption.forEach(item => {
          if (item.value === this.searchParams.type) {
            finallyParams[item.attr] = this.searchParams.value
          }
        })
      } else {
        finallyParams.condition = this.searchParams.value
      }

      let params = {
        params: finallyParams,
        pager: this.pager
      }
      getAccEventCodeList(params).then(data => {
        if (data.code === '00000000') {
          const { results, totalRecords } = data.payload
          this.tableData = results
          this.pager.total = totalRecords
        } else {
          this.errorMessage(data.message)
        }
      })
    }
  },
  mounted() {
    this.getAccEventCodeList()
  }
}
</script>

<style scoped lang="less">
.acc_event_cla {
  margin-top: 15px;
  .acc_search_cla {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/sysOptions/accDevice/accEvent.vue